import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-button_icon-43",
  "use": "icon-button_icon-43-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-button_icon-43\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M16 9l-5.412 6L7 11.021\" /><path d=\"M3 14c0 4.418 3.806 8 8.5 8s8.5-3.582 8.5-8\" /><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3 14V5.964L11.5 2 20 5.964v7.994\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol